import { IStyle } from '@fluentui/react';
import { CommonStyles, FontSizes, IH2OTheme, IListRowStyles, ListRowSizes, Sizes } from '@h2oai/ui-kit';

export interface IFeatureDetailsStyles {
  root?: IStyle;
  contents?: IStyle;
  panels?: IStyle;
  flexPanel?: IStyle;
  rows?: IStyle;
  fieldGroup?: IStyle;
  fields?: IStyle;
  field?: IStyle;
  label?: IStyle;
  value?: IStyle;
}

export interface IFeatureDetailsClassNames {
  root: string;
  contents: string;
  panels: string;
  flexPanel?: string;
  rows: string;
  fieldGroup?: string;
  fields: string;
  field: string;
  label: string;
  value: string;
}

export const featureDetailsStylesDefault = (_theme: IH2OTheme): Partial<IFeatureDetailsStyles> => ({
  root: {
    flex: 1,
  },
  contents: {},
  panels: { display: 'flex', height: ListRowSizes.ContentsContentsHeight },
  rows: {
    paddingBottom: 8,
    borderBottom: '1px solid #70707027',
    marginBottom: 16,
  },
  fieldGroup: {
    paddingLeft: 16,
    paddingRight: 16,
    display: 'flex',
  },
  fields: {
    flex: 1,
    marginRight: 40,
    '&:last-child': {
      marginRight: 0,
    },
  },
  field: {
    marginBottom: 16,
    fontSize: FontSizes.xsmall,
    display: 'flex',
    justifyContent: 'space-between',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  label: { flex: 1, ...CommonStyles.truncateString },
  value: { maxWidth: '50%', ...CommonStyles.truncateString },
  flexPanel: {
    flex: 1,
  },
});

export const featureDetailsStylesFullScreen = (theme: IH2OTheme): Partial<IFeatureDetailsStyles> => ({
  root: { minHeight: 0, overflow: 'auto' },
  contents: {
    border: `1px solid ${theme.palette?.gray300}`,
    borderRadius: Sizes.borderRadius,
    backgroundColor: theme.palette?.white,
    padding: 24,
    marginBottom: 24,
  },
  panels: {
    display: 'block',
    height: 'auto',
  },
  fieldGroup: { paddingBottom: 16 },
  fields: {
    flex: 'inherit',
    width: 200,
    marginRight: 100,
  },
  label: { lineHeight: 17 },
  value: { lineHeight: 17 },
  flexPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
});

export const listRowStylesFeatureDetails: Partial<IListRowStyles> = {
  root: {
    marginBottom: 16,
  },
  row: {
    height: 40,
    '.h2o-ListCell-root': {
      width: '100% !important',
      '.divider': {
        display: 'none',
      },
      '.divider-margin': { display: 'none' },
    },
    '.h2o-ListCell-root:first-child': {
      paddingLeft: 0,
    },
    '&:hover': {
      background: 'transparent',
    },
  },
};
